import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";

// Import components for routes
import Root from "./components/Root";
import ErrorPage from "./components/ErrorPage";
import ProtectedRoute from "./components/features/ProtectedRoute";
import TardinessForm from "./components/delight/TardinessForm";
import ScheduleRequestForm from "./components/delight/ScheduleRequestForm";
import ReportDownload from "./components/delight/ReportDownload";
import PrivacyPolicy from "./components/delight/PrivacyPolicy";
import JiraLikeBoard from "./components/JiraLikeBoard";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: (
          // <ProtectedRoute>
            <TardinessForm />
          // </ProtectedRoute>
        ),
      },
      {
        path: "jira",
        element: <JiraLikeBoard />,
      },
      {
        path: "schedule",
        element: <ScheduleRequestForm />,
      },
      {
        path: "tardiness",
        element: <TardinessForm />,
      },
      {
        path: "reports",
        element: <ReportDownload />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      
    ],
  },
]);

// App component renders RouterProvider with defined router
const App = () => (
  <RouterProvider router={router} />
);

export default App;
